export default __webpack_public_path__ + "static/SRUS LF235 - Especification Del Producto y Datos Técnicos-ef6a95419d37da71a8d58693a8bcbbed.pdf";